import { Card } from '@aether/ui/Card';

export const NoAccess = () => {
  return (
    <Card className="h-full p-4" title="Insufficient permissions">
      <div>You don't have sufficient permissions to access this section of the application.</div>
    </Card>
  );
};
